import { render, staticRenderFns } from "./QuestionRules.vue?vue&type=template&id=1590e5bc&scoped=true&"
import script from "./QuestionRules.vue?vue&type=script&lang=js&"
export * from "./QuestionRules.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRules.vue?vue&type=style&index=0&id=1590e5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590e5bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VExpandTransition,VIcon})
